import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { Button, Input } from '..';
import { useTranslation } from '../../../hooks/useTranslation';
import { useState } from 'react';

interface ConfigureInvoiceNumberProps {
    onSave: () => void;
    onCancel: () => void;
}

enum InvoiceNumberOptions {
    AUTO = 'AUTO',
    MANUAL = 'MANUAL',
}
export const ConfigureInvoiceNumber = ({ onSave, onCancel }: ConfigureInvoiceNumberProps) => {
    const content = useSelector((state: RootState) => state.language.data);
    const { t } = useTranslation('invoice');

    const [value, setValue] = useState<InvoiceNumberOptions>(InvoiceNumberOptions.AUTO);
    const [prefix, setPrefix] = useState<string>('INV-');
    const [nextNumber, setNextNumber] = useState<string>('000001');

    return (
        <div className={'invoice-number'}>
            <div className="invoice-number__container">
                <h3 className="invoice-number__title">{t('configureInvoiceNumberTitle')}</h3>

                <div className="invoice-number__description-container">
                    <p className="paragraph-4">{t('configureInvoiceNumberDescription')}</p>
                </div>

                <div className="invoice-number__radio-buttons-container">
                    <label className="invoice-number__radio-button">
                        <input
                            type="radio"
                            name="invoiceType"
                            value={InvoiceNumberOptions.AUTO}
                            checked={value === InvoiceNumberOptions.AUTO}
                            onChange={() => setValue(InvoiceNumberOptions.AUTO)}
                        />
                        {t('autoGenerate')}
                    </label>
                    {value === InvoiceNumberOptions.AUTO && (
                        <div className="invoice-number__auto-settings">
                            <Input
                                id={t('prefix')}
                                value={prefix}
                                onChange={e => setPrefix(e.target.value)}
                                placeholder={t('prefix')}
                                label={t('prefix')}
                            />
                            <Input
                                id={t('nextNumber')}
                                value={nextNumber}
                                onChange={e => setNextNumber(e.target.value)}
                                placeholder={t('nextNumber')}
                                label={t('nextNumber')}
                            />
                        </div>
                    )}
                    <label className="invoice-number__radio-button">
                        <input
                            type="radio"
                            name="invoiceType"
                            value={InvoiceNumberOptions.MANUAL}
                            checked={value === InvoiceNumberOptions.MANUAL}
                            onChange={() => setValue(InvoiceNumberOptions.MANUAL)}
                        />
                        {t('enterManually')}
                    </label>
                </div>
            </div>

            <div className="invoice-number__action">
                <Button onClick={() => onCancel()} text={content.common.cancel} variant={'text'} />
                <Button text={content.common.saveChanges} onClick={() => onSave()} variant={'contained'} />
            </div>
        </div>
    );
};
